<template>
  <div>
    <div v-if="loadingHanwha" class="tab-content-loading d-flex justify-content-center align-items-center">
      <b-spinner label="Loading" variant="primary" />
    </div>
    <template v-else>
      <div class="row justify-content-center mb-1">
        <div class="col-7">
          <table class="table table-bordered">
            <tr>
              <th>
                <feather-icon
                  icon="ClockIcon"
                  size="15"
                  style="margin-right: 5px;"
                />
                Hora del sistema:
              </th>
              <td>
                <span class="ml-1">{{ currentTime }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
     <!--  <p class="text-center h5 d-flex align-items-center justify-content-center mb-2 mt-1">

      </p> -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
        <b-tabs  justified>
          <b-tab title="Fecha/Hora">
            <div class="tab-content">
              <DateTime :item-data="itemData" :loading="loading"/>
            </div>
          </b-tab>
          <b-tab title="Horario de verano">
            <div class="tab-content">
              <Dst :item-data="itemData" :loading="loading" />
            </div>
          </b-tab>
          <b-tab title="Zona horaria/Idioma">
            <div class="tab-content">
              <TimezoneLanguage
                :item-data="itemData"
                :langs="langs"
                :loading="loading"
                :timezones="timezones"
              />
            </div>
          </b-tab>
          <b-tab title="Vacaciones">
            <div class="tab-content">
              <Holidays
                ref="holidaysRef"
                :item-data="itemData"
                :loading="loading"
                @get-holidays="getHolidays()"
              />
            </div>
          </b-tab>
        </b-tabs>

          <div class="text-right">
            <b-button
              type="submit"
              variant="primary"
              :disabled="loading"
            >
              Guardar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </div>
</template>

<script>
import { onMounted,onUnmounted,ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { required } from '@validations';
import moment from 'moment-timezone';
import popperHelper from "@/libs/popper-helper";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import vSelect from "vue-select";
import formValidation from '@core/comp-functions/forms/form-validation';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import DateTime from './date-time-language/DateTime.vue'
import Dst from './date-time-language/Dst.vue'
import Holidays from './date-time-language/Holidays.vue';
import TimezoneLanguage from './date-time-language/TimezoneLanguage.vue';

export default {
  components: {
    DateTime,
    Dst,
    Holidays,
    TimezoneLanguage,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    hanwhaDvr: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      required
    }
  },
  setup(props, { emit }) {
    const resetData = () => {
      itemData.value = {
        enableConfig: false,
        year: null,
        month: null,
        day: null,
        hours: null,
        minutes: null,
        seconds: null,
        timezone: null,
        enableDST: false,
        startMonthDst: 3,
        startWeekDst: 5,
        startDayDst: 0,
        startHourDst: 1,
        endMonthDst: 10,
        endWeekDst: 5,
        endDayDst: 0,
        endHourDst: 1,
        oldLanguage: null,
        newLanguage: null,
        posixTimezone: null,
        enableHolidays: false,
        holidaysFromApi: {
          month_wise_holidays: [],
          month: new Date().getMonth(),
          year: new Date().getFullYear()
        },
        selectedDays: []
      }
    }

    //HOOKS
    onMounted(async () => await getNvrData());

    onUnmounted(() => clearInterval(interval.value));

    //COMPOSABLES
    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    //DATA
    const currentTime = ref(null);

    const holidaysRef = ref(null);

    const loading = ref(false);

    const loadingHanwha = ref(false);

    const itemData = ref({
      enableConfig: false,
      year: null,
      month: null,
      day: null,
      hours: null,
      minutes: null,
      seconds: null,
      timezone: null,
      enableDST: false,
      startMonthDst: 3,
      startWeekDst: 5,
      startDayDst: 0,
      startHourDst: 1,
      endMonthDst: 10,
      endWeekDst: 5,
      endDayDst: 0,
      endHourDst: 1,
      oldLanguage: null,
      newLanguage: null,
      posixTimezone: null,
      enableHolidays: false,
      holidaysFromApi: {
        month_wise_holidays: [],
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      },
      selectedDays: []
    });

    const interval = ref(null);

    const langs = ref([
      { label: 'Ingles', value: 'English' },
      { label: 'Español', value: 'Spanish' },
      { label: 'Portugues', value: 'Portuguese' }
    ]);

    const nvrDateTime = ref(false);

    const nvrTimezone = ref(null);

    const timezones = ref([
      { label: 'GMT-12:00', value: 'GMT12' },
      { label: 'GMT-11:00', value: 'GMT11' },
      { label: 'GMT-10:00', value: 'GMT10' },
      { label: 'GMT-09:30', value: 'GMT9:30' },
      { label: 'GMT-09:00', value: 'GMT9' },
      { label: 'GMT-08:00', value: 'GMT8' },
      { label: 'GMT-07:00', value: 'GMT7' },
      { label: 'GMT-06:00', value: 'GMT6' },
      { label: 'GMT-05:00', value: 'GMT5' },
      { label: 'GMT-04:00', value: 'GMT4' },
      { label: 'GMT-03:30', value: 'GMT3:30' },
      { label: 'GMT-03:00', value: 'GMT3' },
      { label: 'GMT-02:00', value: 'GMT2' },
      { label: 'GMT-01:00', value: 'GMT1' },
      { label: 'GMT', value: 'GMT0' },
      { label: 'GMT+01:00', value: 'GMT-1' },
      { label: 'GMT+02:00', value: 'GMT-2' },
      { label: 'GMT+03:00', value: 'GMT-3' },
      { label: 'GMT+03:30', value: 'GMT-3:30' },
      { label: 'GMT+04:00', value: 'GMT-4' },
      { label: 'GMT+04:30', value: 'GMT-4:30' },
      { label: 'GMT+05:00', value: 'GMT-5' },
      { label: 'GMT+05:30', value: 'GMT-5:30' },
      { label: 'GMT+05:45', value: 'GMT-5:45' },
      { label: 'GMT+06:00', value: 'GMT-6' },
      { label: 'GMT+06:30', value: 'GMT-6:30' },
      { label: 'GMT+07:00', value: 'GMT-7' },
      { label: 'GMT+08:00', value: 'GMT-8' },
      { label: 'GMT+08:45', value: 'GMT-8:45' },
      { label: 'GMT+09:00', value: 'GMT-9' },
      { label: 'GMT+09:30', value: 'GMT-9:30' },
      { label: 'GMT+10:00', value: 'GMT-10' },
      { label: 'GMT+10:30', value: 'GMT-10:30' },
      { label: 'GMT+11:00', value: 'GMT-11' },
      { label: 'GMT+12:00', value: 'GMT-12' },
      { label: 'GMT+12:45', value: 'GMT-12:45' },
      { label: 'GMT+13:00', value: 'GMT-13' },
      { label: 'GMT+14:00', value: 'GMT-14' }
    ]);

    const timezonLanguageRef = ref(null);

    //METHODS
    const buildDstData = (posfixTimezone) => {
     const regex = /^STWT([+-]?\d+(?::\d+)?)STWST,M(\d+)\.(\d+)\.(\d+)\/(\d+):(\d+):(\d+),M(\d+)\.(\d+)\.(\d+)\/(\d+):(\d+):(\d+)$/;

      const matches = posfixTimezone.match(regex);

      if (!matches) {
          return null;
      }

      const [,gmtTimezone,startMonth,startWeek,startDay,startHour,,,endMonth,endWeek,endDay,endHour] = matches;

      itemData.value.startMonthDst = parseInt(startMonth);
      itemData.value.startWeekDst  = parseInt(startWeek);
      itemData.value.startDayDst   = parseInt(startDay);
      itemData.value.startHourDst  = parseInt(startHour);
      itemData.value.startHourDst  = parseInt(startHour);
      itemData.value.endMonthDst   = parseInt(endMonth);
      itemData.value.endWeekDst    = parseInt(endWeek);
      itemData.value.endDayDst     = parseInt(endDay);
      itemData.value.endHourDst    = parseInt(endHour);

      const timeZoneSelected = timezones.value.find(tz => (tz.value === `GMT${gmtTimezone}`));

      nvrTimezone.value = timeZoneSelected.label;
      itemData.value.timezone =  timeZoneSelected.value;
    }

    const buildTimezone = () => {
      let timezone = itemData.value.timezone;

      if (itemData.value.enableDST) {
        const timezoneDstFormatted = itemData.value.timezone.replace('GMT', '');

        timezone = `STWT${timezoneDstFormatted}STWST,M${itemData.value.startMonthDst}.${itemData.value.startWeekDst}.${itemData.value.startDayDst}/${itemData.value.startHourDst}:00:00,M${itemData.value.endMonthDst}.${itemData.value.endWeekDst}.${itemData.value.endDayDst}/${itemData.value.endHourDst}:00:00`;
      }

      return timezone;
    }

    const getHolidays = async () => {
      const params = {
        id_dvr: props.hanwhaDvr.id,
        action: 'get-holidays',
        year: itemData.value.holidaysFromApi.year
      }

      loading.value = true;

      await axios.get('/v1/hanwha/dvr/admin/get-holidays', { params })
        .then(async (response) => {
          const { data } = response;

          holidaysRef.value.setHolidaysFromApi();
          holidaysRef.value.initDates();
        })
        .catch(() => {

        })
        .finally(() => {
          loading.value = false;
        });
    }

    const getNvrData = async () => {
      const params = {
        id_dvr: props.hanwhaDvr.id,
        year: itemData.value.holidaysFromApi.year
      }

      loadingHanwha.value = true;

      await axios.get('/v1/hanwha/dvr/admin/get-date-time-language-data', { params })
        .then(response => {
          const { data } = response;
          const language = data.data.device_info.Language || 'Spanish'
          const nvrLanguage = langs.value.find(lang => (lang.value === language));

          itemData.value.oldLanguage = nvrLanguage.value;
          itemData.value.newLanguage = nvrLanguage.value;
          itemData.value.enableDST = data.data.timezones.DSTEnable;
          itemData.value.holidaysFromApi.month_wise_holidays = data.data.holidays.MonthWiseHolidays;
          itemData.value.holidaysFromApi.year = data.data.holidays.Year;

          buildDstData(data.data.timezones.POSIXTimeZone);
          initDateTime(data.data.timezones.LocalTime);
          initInterval();
        })
        .catch(() => {

        })
        .finally(() => {
          loadingHanwha.value = false;
        });
    }

    const getHolidaysByMonth = (findDaysSelected = false) => {
      const months      = itemData.value.selectedDays.map(sl => sl.month)
      const monthsSet   = new Set(months);
      const monthsArray = [...monthsSet];
      const holidays    = [];

      monthsArray.forEach(monthNumeber => {
        let holidaysDays = [];

        holidaysDays = itemData.value.selectedDays.filter(s => {
            if (findDaysSelected) {
              return (s.month === monthNumeber) && (s.selected === findDaysSelected);
            }

            return (s.month === monthNumeber) && (s.selected === findDaysSelected) && (s.fromApi)
        });

        if (holidaysDays.length) {
          const arrayDays = holidaysDays.map(day => day.day);

          holidays.push({
            month: monthNumeber,
            days: arrayDays
          })
        }
      });

      return holidays;
    }


    const groupHolidays = () => {
      const holidays = {
        year: itemData.value.holidaysFromApi.year,
        holidaysSelected: getHolidaysByMonth(true),
        holidaysUnselected: getHolidaysByMonth()
      }

      return holidays;
    }

    const initDateTime = (localTime) => {
      const dateTime = moment(localTime, 'YYYY-MM-DD HH:mm:ss');

      nvrDateTime.value = moment(localTime, 'YYYY-MM-DD HH:mm:ss');

      itemData.value.year    = dateTime.year();
      itemData.value.month   = dateTime.month() + 1;
      itemData.value.day     = dateTime.date();
      itemData.value.hours   = dateTime.hours();
      itemData.value.minutes = dateTime.minutes();
      itemData.value.seconds = dateTime.seconds();
    }

    const initInterval = () => {
      updateTime();

      interval.value = setInterval(() => {
        updateTime();
      }, 1000);
    }

    const onSubmit = async () => {
      const request = {
        id_dvr: props.hanwhaDvr.id,
        year: itemData.value.year,
        month: itemData.value.month,
        day: itemData.value.day,
        hours: itemData.value.hours,
        minutes: itemData.value.minutes,
        seconds: itemData.value.seconds,
        enableConfig: itemData.value.enableConfig,
        enableDST: itemData.value.enableDST,
        oldLanguage: itemData.value.oldLanguage,
        newLanguage: itemData.value.newLanguage,
        timezone: buildTimezone(),
        enableHolidays: itemData.value.enableHolidays,
        holidays: []
      }

      if (itemData.value.enableHolidays) {
        request.holidays = groupHolidays();
      }

      loading.value = true;

      await axios.post('/v1/hanwha/dvr/admin/set-date-time-language', request)
        .then(async (response) => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          clearInterval(interval.value);
          await getNvrData();

          holidaysRef.value.setHolidaysFromApi();
          holidaysRef.value.initDates();
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error al guardar la información',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const updateTime = () => {
      const timezoneOffset = (nvrTimezone.value === 'GMT') ? 0 : nvrTimezone.value.replace('GMT', '');

      nvrDateTime.value = nvrDateTime.value.clone().add(1, 'second');

      currentTime.value = nvrDateTime.value.utcOffset(timezoneOffset).format('DD/MM/YYYY HH:mm:ss');
    }

    return {
      getValidationState,
      resetForm,
      refFormObserver,

      currentTime,
      itemData,
      holidaysRef,
      langs,
      loading,
      loadingHanwha,
      timezones,
      timezonLanguageRef,

      getHolidays,
      getNvrData,
      onSubmit,
      withPopper: popperHelper.withPopper
    }
  }
}
</script>

<style scoped>
.tab-content-loading {
  height: 550px !important;
}

.tab-content {
  height: 380px !important;
}

table.table tr th {
  background-color: #f8f9fa;
}
</style>
